export default {
  END_POINT: 'https://drmekclinic.pams.ai/api/dataadapter/apicall/2bzW4KUyPxWXv40y52MhhBIjBQd',
  AUTH: 'VrxrLWHWeQwf0@uUYwWYyILp2ygRmyeIQvavgUbsrzFyU20wyIHX7A0YDCZLezHGP'
}



// WEBPACK FOOTER //
// ./src/config/doctor-mek.js